export type AssetPaths = {
  step1Icon: string
  step2Icon: string
  step3Icon: string
  connectingLine1: string
  connectingLine2: string
}

/**
 * Loads brand-specific assets asynchronously with fallback to default assets.
 * Assets are loaded using dynamic imports to avoid bloating the bundle.
 *
 * @param brandCode - The brand code to load assets for
 * @returns Promise resolving to asset paths
 */
export const loadBrandAssets = async (
  brandCode: string
): Promise<AssetPaths> => {
  // Try to load brand-specific assets first
  try {
    // Load all brand-specific assets
    const [step1, step2, step3, line1, line2] = await Promise.all([
      import(`./assets/${brandCode}/step1-icon.svg`),
      import(`./assets/${brandCode}/step2-icon.svg`),
      import(`./assets/${brandCode}/step3-icon.svg`),
      import(`./assets/${brandCode}/connecting-line-1.svg`),
      import(`./assets/${brandCode}/connecting-line-2.svg`)
    ])

    return {
      step1Icon: step1.default.src || step1.default,
      step2Icon: step2.default.src || step2.default,
      step3Icon: step3.default.src || step3.default,
      connectingLine1: line1.default.src || line1.default,
      connectingLine2: line2.default.src || line2.default
    }
  } catch {
    // Fallback to default assets if brand-specific assets don't exist
    const [
      step1Default,
      step2Default,
      step3Default,
      line1Default,
      line2Default
    ] = await Promise.all([
      import('./assets/default/step1-icon.svg'),
      import('./assets/default/step2-icon.svg'),
      import('./assets/default/step3-icon.svg'),
      import('./assets/default/connecting-line-1.svg'),
      import('./assets/default/connecting-line-2.svg')
    ])

    return {
      step1Icon: step1Default.default.src || step1Default.default,
      step2Icon: step2Default.default.src || step2Default.default,
      step3Icon: step3Default.default.src || step3Default.default,
      connectingLine1: line1Default.default.src || line1Default.default,
      connectingLine2: line2Default.default.src || line2Default.default
    }
  }
}
